import React, { useEffect, useState } from "react"
import { IUpdateProfileDto } from "../../../types/user/IUpdateProfileDto"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { ModalPopUp } from "./ModalPopUp"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { CommonInput } from "./fields/CommonInput"
import { IErrorModel } from "../../../types/error/IErrorModel"

export const ProfileEdit: React.FC<{ visible: boolean; setVisible: (visible: boolean) => void }> = ({
  visible,
  setVisible
}) => {
  const [profile, setProfile] = useState<IUpdateProfileDto>()
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [errors, setErrors] = useState<IErrorModel>()

  useEffect(() => {
    TrinityAPI.getProfile(response => {
      if (response.status === 200) {
        setProfile(response.data)
      } else {
        setModalMessage({ title: "Ошибка!", text: "Ошибка получения профиля: " + response.data.message })
      }
    })
  }, [])

  const submit = () => {
    TrinityAPI.updateProfile(profile, response => {
      if (response.status === 200) {
        setProfile(response.data)
        window.location.reload()
      } else {
        setErrors(response.data)
      }
    })
  }

  if (visible) {
    return (
      <>
        <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
        <section className="popup-forms" id="admin-profile">
          <div className="container-popup-forms">
            <button className="close-btn-card" id="admin-profile-close" onClick={() => setVisible(false)} />
            <div className="popup-card">
              <h4 className="heading-chapter">Профиль</h4>
              <CommonInput
                typeName={"text"}
                label={"Имя"}
                placeholder={"Иван Иванов"}
                name={"name"}
                value={profile?.name}
                errorModel={errors}
                _callback={e => setProfile({ ...profile, name: e })}
              />
              <CommonInput
                typeName={"text"}
                label={"Телеграм"}
                placeholder={"nickname"}
                name={"telegram"}
                value={profile?.telegram}
                errorModel={errors}
                _callback={e => setProfile({ ...profile, telegram: e })}
              />
              <CommonInput
                typeName={"text"}
                label={"Телефон"}
                placeholder={"+00000000000"}
                name={"phone"}
                value={profile?.phone}
                errorModel={errors}
                _callback={e => setProfile({ ...profile, phone: e })}
              />
              <div className="flex-row-24">
                <button className="btn" onClick={submit}>
                  Сохранить
                </button>
                <button className="btn grey-btn" onClick={() => setVisible(false)}>
                  Отменить
                </button>
              </div>
            </div>
          </div>
        </section>
      </>
    )
  } else {
    return <></>
  }
}
